import { NoxusIcon } from "../UI/NoxusIcon";

export function EntityDialogTitle({
  action,
  icon,
  name,
}: {
  // The verb the dialog's confirm button uses, so the two agree.
  action: string;
  // A WORKFLOW_ICONS key, or a ready-made visual for entities that have no
  // icon of their own (a user's avatar, a role's badge).
  icon?: string | React.ReactNode;
  // Omitted when the visual already names the entity, as a role badge does.
  name?: string;
}) {
  return (
    // pr-6 keeps a long name clear of the dialog's close button, which is
    // absolutely positioned over the header.
    <span className="flex items-center gap-2 min-w-0 pr-6">
      <span className="shrink-0">{action}</span>
      {typeof icon === "string" ? <NoxusIcon icon={icon} size="sm" /> : icon}
      {name && <span className="truncate min-w-0">{name}</span>}
    </span>
  );
}
